
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.8 20v-8.5l8.6 4.3z"}}),_c('path',{attrs:{"d":"M27.6 23.1c0 .9-.7 1.7-1.7 1.7H6.1c-.9 0-1.7-.7-1.7-1.7V8.9c0-.9.7-1.7 1.7-1.7H26c.9 0 1.7.7 1.7 1.7V23h-.1v.1z"}})])
          )
        }
      }
    